module.exports = __webpack_public_path__ + "img/specialPost1.159ac3ad.png";